import SoftBreak from '../formats/SoftBreak';
import type { Line } from '../types';

export const getFirstNonSoftLine = <T extends Line>(blot: T) => {
  let current: T = blot;
  while (
    current.prev &&
    current.prev.constructor === current.constructor &&
    SoftBreak.value(current.domNode)
  ) {
    current = current.prev as T;
  }
  return current;
};

const getItemAllLines = <T extends Line>(blot: T) => {
  const firstLine = getFirstNonSoftLine(blot);

  const result = [firstLine];

  let currentBlot = firstLine.next;
  while (
    currentBlot &&
    currentBlot.constructor === firstLine.constructor &&
    SoftBreak.value(currentBlot.domNode as HTMLElement)
  ) {
    result.push(currentBlot as T);
    currentBlot = currentBlot.next;
  }

  return result;
};

export default getItemAllLines;
